import { obterMecanicosAsync } from "../../services/mecanicoService";

const atualizarMecanicos = async ({ commit }) => {
    const mecanicos = await obterMecanicosAsync();
    commit('atualizarMecanicos', mecanicos);
}

const atualizarMecanico = ({ commit }, mecanico) => {
    commit('atualizarMecanico', mecanico);
}

const updateMecanico = ({ commit }, mecanico) => {
    commit('updateMecanico', mecanico);
}

export default {
    atualizarMecanicos,
    atualizarMecanico,
    updateMecanico
}